import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { RenderConfigurationService } from 'render/services/render-configuration.service';
import { BreakPoint, DeviceType } from 'app.config';

@Injectable()
export class DeviceInfoService {

  // Store on the Observable just the last value emitted
  public breakpointState: ReplaySubject<DeviceType> = new ReplaySubject<DeviceType>(1);

  // Cached last value emitted to compare when changes
  private lastBreakpointState?: DeviceType;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private renderConfigurationService: RenderConfigurationService,
  ) {
    this._useBreakPointObserver();
  }

  private _useBreakPointObserver() {
    // Para cada Breakpoint de la config
    this.renderConfigurationService.config.breakpoints.forEach((breakPoint: BreakPoint) => {
      // Escuchamos si el dispositivo cumple
      this.breakpointObserver.observe(breakPoint.bp).subscribe((state: BreakpointState) => {
        // Si cumple y es distinto al valor que teníamos, guardamos y emitimos el estado
        const newState = state.matches ? breakPoint.device[0] : this.lastBreakpointState;
        if ((newState !== undefined) && (newState !== this.lastBreakpointState)) {
          this.lastBreakpointState = newState;
          this.breakpointState.next(this.lastBreakpointState);
        }
      });
    });
  }

}
